/**
 * CORE-1404 — возрастной выбор на старте регистрации.
 *
 * Два вопроса подряд: «Мне есть 18» / «Мне меньше 18», и для второго ответа —
 * «Мне есть 14» / «Мне меньше 14». Младше 14 регистрация недоступна (п.14.1
 * Политики обработки ПДн); 14–17 — аккаунт с ограничениями до решения юриста.
 *
 * Логика вынесена из компонента, чтобы её можно было проверить без рендерера.
 */

/** То, что уходит на сервер. `under14` — только отказ, у пользователя не хранится. */
export type AgeGroup = 'adult' | 'teen' | 'under14';

export type AgeStep =
  | { kind: 'ask18' }
  | { kind: 'ask14' }
  | { kind: 'done'; ageGroup: AgeGroup };

export type AgeAnswer = 'is18' | 'below18' | 'is14' | 'below14' | 'reset';

export const initialAgeStep: AgeStep = { kind: 'ask18' };

export function nextAgeStep(step: AgeStep, answer: AgeAnswer): AgeStep {
  if (answer === 'reset') return initialAgeStep;
  if (step.kind === 'ask18') {
    if (answer === 'is18') return { kind: 'done', ageGroup: 'adult' };
    if (answer === 'below18') return { kind: 'ask14' };
  }
  if (step.kind === 'ask14') {
    if (answer === 'is14') return { kind: 'done', ageGroup: 'teen' };
    if (answer === 'below14') return { kind: 'done', ageGroup: 'under14' };
  }
  return step;
}

/** Выбор сделан и регистрация разрешена. */
export function canRegisterWithAge(step: AgeStep): step is { kind: 'done'; ageGroup: 'adult' | 'teen' } {
  return step.kind === 'done' && step.ageGroup !== 'under14';
}

export function isAgeBlocked(step: AgeStep): boolean {
  return step.kind === 'done' && step.ageGroup === 'under14';
}
